import { usePathname, useSearchParams } from 'next/navigation';
import React from 'react';
import { Button, ButtonProps } from 'ui-components/common/Button';
import { Link } from 'ui-components/common/Link';
import { useClient } from 'ui-hooks/useClient';
import { useRequestCertificate } from 'ui-hooks/useRequestCertificate';
import { buildCertificateUrl } from 'utils/url';

export const CertificateLinkButton = ({ className, ...props }: ButtonProps) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const client = useClient();
  const requestCertificate = useRequestCertificate();
  const link = buildCertificateUrl(`${pathname}?${searchParams?.toString()}`);

  if (client.isApp) {
    return <Button onClick={requestCertificate} {...props} className={className} />;
  }

  return (
    <Link href={link} className={className}>
      <Button {...props} />
    </Link>
  );
};
